const apiUrl = process.env.REACT_APP_API_URL;

export const endpoints = {
  userData: `${apiUrl}/userdata`,
  category: `${apiUrl}/category`,
  expense: `${apiUrl}/expense`,
  income: `${apiUrl}/income`,
  incomeMonth: `${apiUrl}/income/month`,
  budget: `${apiUrl}/budget`,
  closeBudget: `${apiUrl}/budget/close`,
  preferences: `${apiUrl}/preferences`,
  currency: `${apiUrl}/currency`,
  budgetMonth: {
    all: `${apiUrl}/budgetmonth`,
    income: `${apiUrl}/budgetmonth/income`,
    budget: `${apiUrl}/budgetmonth/budget`,
    residue: `${apiUrl}/budgetmonth/residue`
  },
  auth: {
    login: `${apiUrl}/auth`,
    register: `${apiUrl}/auth/register`,
    sendConfirmEmail: `${apiUrl}/auth/sendConfirmEmail`,
    confirmEmail: `${apiUrl}/auth/confirmEmail`
  }
};
